function normalizeAddress(address) {
  return address ? address.toLowerCase() : '';
}

export default normalizeAddress;